<template>
  <div>
    <v-container v-if="showTitleBar" fluid fill-width class="ma-0 pa-0">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <v-card color="#eeeeee" class="pt-1">
            <v-card-title class="primary--text pl-3 py-2"
              >{{ title }}

              <v-divider vertical class="ml-4 mr-4"> </v-divider>

              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on: tooltip }">
                  <span v-on="{ ...tooltip }">
                    <v-chip
                      label
                      color="primary"
                      class="white--text title mr-2"
                      >{{ cohorts.length }}</v-chip
                    >
                    <span class="black--text text-body-1"
                      >Study group{{ cohorts.length == 1 ? '' : 's' }}</span
                    >
                  </span>
                </template>
                <span class="subtitle-1">
                  {{ cohorts.length }} Study group{{
                    cohorts.length == 1 ? '' : 's'
                  }}
                </span>
              </v-tooltip>

              <v-divider v-if="showSelect" vertical class="ml-4 mr-4">
              </v-divider>

              <v-tooltip v-if="showSelect" bottom color="primary">
                <template v-slot:activator="{ on: tooltip }">
                  <span v-on="{ ...tooltip }">
                    <v-chip
                      label
                      color="primary"
                      class="white--text title mr-2"
                      >{{ selected.length }}</v-chip
                    >
                    <span class="black--text text-body-1">Selected</span>
                  </span>
                </template>
                <span class="subtitle-1">
                  {{ selected.length }} Study group{{
                    selected.length == 1 ? '' : 's'
                  }}
                  selected
                </span>
              </v-tooltip>

              <v-tooltip v-if="showColors" bottom color="primary">
                <template v-slot:activator="{ on: tooltip }">
                  <span v-on="{ ...tooltip }">
                    <v-btn
                      :disabled="selected.length == 0"
                      small
                      color="primary"
                      class="white--text mr-2 ml-5"
                      @click="openCohortColorPickerDialog(null)"
                      >Set Color{{ selected.length == 1 ? '' : 's' }}</v-btn
                    >
                  </span>
                </template>
                <span class="subtitle-1">
                  Set color and/or fill pattern for
                  {{ selected.length }} selected study group{{
                    selected.length == 1 ? '' : 's'
                  }}
                </span>
              </v-tooltip>

              <v-spacer />
              <v-toolbar-items>
                <v-icon v-if="expandedVert" @click="expandedVert = false"
                  >expand_less</v-icon
                >
                <v-icon v-else @click="expandedVert = true">expand_more</v-icon>
              </v-toolbar-items>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-sheet v-show="expandedVert" color="white" class="rounded-lg shadow">
      <!-- no cohorts selected -->
      <v-container
        v-if="!cohorts || cohorts.length == 0"
        fluid
        fill-width
        class="ma-0 pa-0"
      >
        <v-row class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <div column align-center justify-center fill-width class="py-3">
              <v-subheader class="title primary--text text--lighten-5">
                {{ noCohortsMessage }}
              </v-subheader>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- cohorts selected -->
      <v-data-table
        v-else
        v-model="selected"
        :headers="headers"
        :items="cohorts"
        item-key="id"
        :show-select="showSelect"
        :disable-pagination="disablePagination"
        :hide-default-footer="disablePagination"
        :dense="dense"
      >
        <!-- Add "All:" to select all checkbox -->
        <template v-slot:header.data-table-select="{ on, props }">
          <v-tooltip top color="primary">
            <template v-slot:activator="{ on: tooltip }">
              <span
                class="text-subtitle-1 font-weight-bold"
                v-on="{ ...tooltip }"
              >
                All: <v-simple-checkbox v-bind="props" v-on="on"
              /></span>
            </template>
            <span>Click to select all study groups.</span>
          </v-tooltip>
        </template>

        <template v-slot:item.data-table-select="{ isSelected, select }">
          <td class="pa-0 ma-0" justify="center" align="center">
            <v-tooltip v-if="checkboxTooltip" bottom color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-simple-checkbox
                  :value="isSelected"
                  class="pa-0 ma-0"
                  dense
                  hide-details
                  v-on="{ ...tooltip }"
                  @input="select($event)"
                />
              </template>
              <span>{{ checkboxTooltip }}</span>
            </v-tooltip>
            <v-simple-checkbox
              v-else
              :value="isSelected"
              class="pa-0 ma-0"
              dense
              hide-details
              @input="select($event)"
            />
          </td>
        </template>

        <template v-slot:item.label="{ item }">
          <td class="subtitle-1 text-xs-left">
            <span>{{ item.label.replace(/^\[O\]_/, '') }}</span>
          </td>
        </template>

        <template v-slot:item.size="{ item }">
          <td class="subtitle-1 text-xs-left">
            <!-- {{ item.subject_ids.length }} -->
            {{ item.subject_ids ? item.subject_ids.length : '?' }}
          </td>
        </template>
        <template v-slot:item.query_string="{ item }">
          <td class="subtitle-1 text-xs-left">{{ item.query_string }}</td>
        </template>

        <template v-slot:item.color="{ item }">
          <v-tooltip top color="primary">
            <template v-slot:activator="{ on: tooltip }">
              <svg
                width="50"
                height="25"
                class="mt-1"
                v-on="{ ...tooltip }"
                @click="openCohortColorPickerDialog(item)"
              >
                <g>
                  <rect
                    x="0"
                    y="0"
                    rx="0"
                    ry="0"
                    border-radius="0%"
                    width="50"
                    height="25"
                    :fill="item['color']"
                    stroke="black"
                  />
                  <rect
                    v-if="
                      item['pattern'] != null &&
                        typeof item['pattern'] == 'object'
                    "
                    x="0"
                    y="0"
                    rx="0"
                    ry="0"
                    border-radius="0%"
                    width="50"
                    height="25"
                    :fill="'url(#' + item['pattern']['id'] + ')'"
                  />
                </g>
              </svg>
            </template>
            <span
              >Click to change color/pattern for study group '{{
                item.label
              }}'</span
            >
          </v-tooltip>
        </template>
      </v-data-table>

      <div
        v-if="reportEmptyCohorts && emptyCohortsSelected.length > 0"
        class="ma-0 pa-0 mt-1"
      >
        <div
          v-for="(c, nc) in emptyCohortsSelected"
          :key="'ecs-' + nc"
          class="pa-1 red lighten-4 mt-1"
        >
          <v-icon class="pa-1" color="error" medium>error</v-icon>
          <span class="font-weight-regular">{{
            "ERROR: selected study group '" + c.label + "' contains no subjects"
          }}</span>
        </div>
      </div>

      <div
        v-if="reportMaxOverlap || reportMaxSelectedOverlap"
        class="ma-0 pa-0 mt-1"
      >
        <div
          v-if="reportMaxOverlap && maxOverlap"
          class="pa-1 yellow lighten-4"
        >
          <v-icon class="pa-1" color="warning" medium>warning</v-icon>
          <span class="font-weight-regular">{{
            'WARNING: ' + maxOverlap.descr
          }}</span>
        </div>
        <div
          v-if="reportMaxSelectedOverlap && maxSelectedOverlap"
          class="pa-1 yellow lighten-4"
        >
          <v-icon class="pa-1" color="warning" medium>warning</v-icon>
          <span class="font-weight-regular">{{
            'WARNING: ' + maxSelectedOverlap.descr
          }}</span>
        </div>
      </div>
    </v-sheet>

    <cohort-color-picker-dialog
      :show="cohortColorPickerDialog"
      :cohort="colorPickerCohort"
      :cohorts="cohorts"
      :selected-cohorts="selected"
      @cohortColorChange="cohortColorChange"
      @dialogClosed="closeCohortColorPickerDialog"
    >
    </cohort-color-picker-dialog>
  </div>
</template>

<script>
import { format } from 'd3-format';
import CohortColorPickerDialog from '@/components/common/CohortColorPickerDialog.vue';

export default {
  components: {
    CohortColorPickerDialog,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Study Groups',
    },
    showTitleBar: {
      type: Boolean,
      required: false,
      default: true,
    },
    dense: {
      type: Boolean,
      required: false,
      default: true,
    },
    cohorts: {
      type: Array,
      required: true,
    },
    // cohorts to select on initial load
    selectCohorts: {
      type: Array,
      required: false,
      default: () => [],
    },
    showSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    showColors: {
      type: Boolean,
      required: false,
      default: false,
    },
    reportMaxSelectedOverlap: {
      type: Boolean,
      required: false,
      default: false,
    },
    reportMaxOverlap: {
      type: Boolean,
      required: false,
      default: false,
    },
    reportEmptyCohorts: {
      type: Boolean,
      required: false,
      default: false,
    },
    disablePagination: {
      type: Boolean,
      required: false,
      default: false,
    },
    checkboxTooltip: {
      type: String,
      required: false,
      default: 'Check to select this study group.',
    },
    expanded: {
      type: Boolean,
      required: false,
      default: true,
    },
    noCohortsMessage: {
      type: String,
      required: false,
      default: 'No study groups selected.',
    },
  },
  data() {
    return {
      selected: [],
      expandedVert: true,
      maxOverlap: null,
      maxSelectedOverlap: null,
      emptyCohortsSelected: [],
      cohortColorPickerDialog: false,
      colorPickerCohort: null,
      propagateChanges: true,
    };
  },
  computed: {
    headers() {
      var hdrs = [];
      hdrs.push({
        text: 'Name',
        value: 'label',
        class: 'text-subtitle-1 font-weight-bold variable-header',
      });

      if (this.showColors) {
        hdrs.push({
          text: 'Color',
          value: 'color',
          class: 'text-subtitle-1 font-weight-bold variable-header',
          sortable: false,
        });
      }

      if (this.expanded) {
        hdrs.push({
          text: 'Size',
          value: 'subject_ids.length',
          class: 'text-subtitle-1 font-weight-bold variable-header',
          sortable: true,
        });

        hdrs.push({
          text: 'Query',
          value: 'query_string',
          class: 'text-subtitle-1 font-weight-bold variable-header',
        });
      }

      return hdrs;
    },
  },
  watch: {
    cohorts(c_new, c_old) {
      if (this.showSelect) {
        // workaround - check whether the cohorts in the list are the same
        let sameCohorts = true;
        let ncn = c_new.length;
        let nco = c_old.length;

        if (ncn != nco) {
          sameCohorts = false;
        } else {
          for (let i = 0; i < ncn; ++i) {
            if (ncn[i] !== nco[i]) {
              sameCohorts = false;
              break;
            }
          }
        }
        if (!sameCohorts) {
          this.maxOverlap = null;
          this.maxSelectedOverlap = null;
          this.deselectAll();
        }
      }
    },
    selected(nsel) {
      if (this.propagateChanges) {
        this.$emit('selectedCohorts', nsel);
      }
      // compute and store maximum overlap between any two _selected_ cohorts
      if (this.reportMaxSelectedOverlap) {
        var max_o = this.computeMaxOverlap(nsel);
        this.maxSelectedOverlap = max_o;
        this.$emit('maxSelectedOverlap', max_o);
      } else {
        this.maxSelectedOverlap = null;
      }
      var emptyCohorts = [];
      nsel.forEach(c => {
        if (c.subject_ids.length <= 0) {
          emptyCohorts.push(c);
        }
      });
      this.emptyCohortsSelected = emptyCohorts;
      if (this.propagateChanges) {
        this.$emit('selectedEmptyCohorts', emptyCohorts);
      }
    },
    selectCohorts(nsel) {
      this.propagateChanges = false;
      this.selected = nsel;
      this.$nextTick(() => {
        this.propagateChanges = true;
      });
    },
  },
  created() {
    // compute and store maximum overlap between any two cohorts
    if (this.reportMaxOverlap) {
      var max_o = this.computeMaxOverlap(this.cohorts);
      this.maxOverlap = max_o;
      this.$emit('maxOverlap', max_o);
    } else {
      this.maxOverlap = null;
      this.maxSelectedOverlap = null;
    }
    if (this.selectCohorts) {
      let ch = {};
      this.cohorts.map(c => {
        ch[c.id] = 1;
      });
      this.selected = this.selectCohorts.filter(c => c.id in ch);
    }
  },
  methods: {
    computeMaxOverlap(cohorts) {
      var overlaps = this.computeOverlaps(cohorts);
      var sortedOverlaps = overlaps.sort((a, b) => b.max_pct - a.max_pct);

      if (overlaps.length > 0) {
        return sortedOverlaps[0];
      } else {
        return null;
      }
    },
    computeOverlaps(cohorts) {
      var overlaps = [];

      // build subject id index for each cohort
      var subjIdsH = [];
      cohorts.forEach(c => {
        var h = {};
        c.subject_ids.forEach(s => {
          h[s] = 1;
        });
        subjIdsH.push(h);
      });

      // perform all vs. all comparison (N^2)
      var nc = cohorts.length;
      for (var i = 0; i < nc; ++i) {
        for (var j = i + 1; j < nc; ++j) {
          // compare i and j
          var n_in_both = 0;
          cohorts[i].subject_ids.forEach(s => {
            if (s in subjIdsH[j]) {
              ++n_in_both;
            }
          });
          if (n_in_both == 0) {
            continue;
          }
          var a_pct = (n_in_both / cohorts[i].subject_ids.length) * 100.0;
          var b_pct = (n_in_both / cohorts[j].subject_ids.length) * 100.0;
          var descr = null;
          var max_pct = null;
          var plural_subject = n_in_both > 1 ? 'subjects' : 'subject';
          var plural_is = n_in_both > 1 ? 'are' : 'is';

          if (a_pct > b_pct) {
            max_pct = a_pct;
            descr =
              n_in_both +
              ' ' +
              plural_subject +
              ' (' +
              format('.1f')(a_pct) +
              "%) from study group '" +
              cohorts[i].label +
              "' " +
              plural_is +
              " also in study group '" +
              cohorts[j].label +
              "'";
          } else {
            max_pct = b_pct;
            descr =
              n_in_both +
              ' ' +
              plural_subject +
              ' (' +
              format('.1f')(b_pct) +
              "%) from study group '" +
              cohorts[j].label +
              "' " +
              plural_is +
              " also in study group '" +
              cohorts[i].label +
              "'";
          }
          overlaps.push({
            a: cohorts[i],
            b: cohorts[j],
            a_pct: a_pct,
            b_pct: b_pct,
            max_pct: max_pct,
            n_in_both: n_in_both,
            descr: descr,
          });
        }
      }
      return overlaps;
    },
    deselectAll() {
      this.selected = [];
    },
    cohortColorChange(cce) {
      this.$emit('cohortColorChange', cce);
    },
    openCohortColorPickerDialog(cohort) {
      // single cohort
      if (cohort != null) {
        this.colorPickerCohort = cohort;
      } else if (cohort == null && this.selected.length == 1) {
        this.colorPickerCohort = this.selected[0];
      } else {
        this.colorPickerCohort = null;
      }
      this.cohortColorPickerDialog = true;
    },
    closeCohortColorPickerDialog() {
      this.colorPickerCohort = null;
      this.cohortColorPickerDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
tr.selectedRow {
  background-color: rgb(236, 177, 212);
}
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}

::v-deep .variable-header {
  white-space: nowrap;
}
</style>
